import { AuthRoute } from '@/system-modules/auth/v1/api/AuthRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { TokenState } from '@/contracts/system-modules/auth/dto/token/TokenState'
import { OFFLINE_DEVICE_UUID, OFFLINE_USER } from '@/system-modules/auth/v1/api/v1/auth/Register/RegisterRoute'

export class CheckTokenRoute extends AuthRoute<null, TokenState> {
  type(): EnumRouteType {
    return EnumRouteType.POST
  }

  url(): string {
    return '/api/system/v1/auth/token/check'
  }

  offline(): Promise<ApiResponse<TokenState>> {
    return Promise.resolve(new ApiResponse({
      success: true,
      data: new TokenState({
        ...OFFLINE_USER,
        deviceUuid: OFFLINE_DEVICE_UUID,
        token: 'offline-token',
        expiresAt: new Date(Date.now() + 900000).toISOString(),
      }),
    }))
  }
}
